









import { Component, Prop, Vue } from 'vue-property-decorator';
import TextField from '@/components/room/status/chatList/chat/content/form/TextField.vue';
import SendButton from '@/components/room/status/chatList/chat/content/form/SendButton.vue';
import { store } from '@/utils/store';

@Component({
  components: {
    TextField,
    SendButton,
  },
})
export default class Form extends Vue {
  @Prop({ required: true }) id!: string;
  message = ''

  sendMessage(e: Event) {
    e.preventDefault();
    if (this.message === '') return;
    store.sendMessage(this.id, this.message);
    this.message = '';
  }
}
